module.exports = __webpack_public_path__ + "static/img/2.7878a63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doc/2.png
// module id = RKrY
// module chunks = 0